<template>
    <v-container>
        <v-row class="contentRow">
            <v-col>
                <h1 class="text-left darkColor--text">Submitter View</h1>
			</v-col>
			<v-col cols="12">
				<p class="darkColor--text">
					This is your overview of audits that you have been sent.
					Pending audits await your attention.
					<br />Completed audits have been submitted, you will not be notified of any future status changes.
				</p>
			</v-col>
            <v-tabs background-color="transparent" light centered icons-and-text>
                <v-tab>
                    Pending
                    <v-icon>fas fa-history fa-flip-horizontal</v-icon>
                </v-tab>

                <v-tab>
                    Submitted
                    <v-icon>fas fa-check</v-icon>
                </v-tab>
                <v-tab-item>
					<br />
                    <v-card elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Pending Audits</h3>
                        </v-card-title>
                        <v-data-table
                            :loading="loading"
                            theme--
                            light
                            :headers="headersPending"
                            :items="pendingaudits"
                            :items-per-page="20"
                            class="light table mx-4 pending-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
							<template v-slot:item.expiryDate="{ item }">
                                <span
									:class= "getColorsForExpiry(item.expiryDate)">
									{{ item.expiryDate }}
								</span>
                            </template>
                            <template v-slot:item.complete="{ item }">
                                <v-btn
                                    :to="'/audit/submitter/'+item.id"
                                    color="primary"
                                    label
                                    small
                                >
                                    {{item.complete}}
                                    Complete
                                    <v-icon right small>fas fa-pencil-alt</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                    <br />
                </v-tab-item>
                <v-tab-item>
                    <br />
                    <v-card elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Submitted Audit Requests</h3>
                        </v-card-title>
                        <v-data-table
                            :loading="loading"
                            theme--
                            light
                            :headers="headersCompleted"
                            :items="completedaudits"
                            :items-per-page="20"
                            class="light table mx-4 completed-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.view="{ item }">
                                <v-btn
                                    :to="'/audit/audits/'+item.id"
                                    color="primary"
                                    label
                                    small
                                >
                                    {{item.view}}
                                    View
                                    <v-icon right small>far fa-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-row>
    </v-container>
</template>

<script>
import AuditRequestsAPI from "../../api/audit/request"
import AuditsAPI from "../../api/audit/audit"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "SupplierAuditOverview",

	data() {
		return {
			headersPending: [
				// {
				// 	text: "Audit ID",
				// 	align: "start",
				// 	sortable: false,
				// 	value: "id",
				// 	class: "secondary--text"
				// },
				{
					text: "Auditor",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Days until Expiry",
					value: "expiryDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				}
			],

			headersCompleted: [
				// {
				// 	text: "Audit ID",
				// 	align: "start",
				// 	sortable: false,
				// 	value: "id",
				// 	class: "secondary--text"
				// },
				{
					text: "Auditor",
					value: "recipient",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				}
			],

			pendingaudits: [],
			completedaudits: [],
			id: false,
			client: false,
			timestamp: false,
			template: false,
			dialogDelete: false,
			loading: false,
		}
	},
	mounted() {
		this.loadPendingAudits()
		this.loadCompletedAudits()
		let createAccess = this.$accessToOperation("AU", "C")
		if (createAccess) {
			this.headersPending.push(
				{
					text: "Complete",
					value: "complete",
					sortable: false,
					class: "secondary--text"
				}
			)
		}
	},

	methods: {
		loadCompletedAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditsAPI.list({type: "outgoing", flowDown:0})
				.then(result => {
					this.completedaudits = []
					for (let entry of result.items) {
						this.completedaudits.push({
							id: entry.id,
							recipient: entry.recipientName || entry.recipient,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							template: entry.templateName,
							view: null
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadPendingAudits() {
			let createAccess = this.$accessToOperation("AU", "C")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditRequestsAPI.list({type:"incoming",flowDown:0})
				.then(result => {
					const currentDate = new Date()
					this.pendingaudits = []
					for (let entry of result.items) {
						const expiryDate = new Date(entry.expirydate) // Convert expiry date string to Date object
						const timeDifference = expiryDate - currentDate
						let daysToExpiry = Math.round(timeDifference/ (1000 * 60 * 60 * 24))
						if( daysToExpiry <= 0 ){
							daysToExpiry = "Expired"
						}
						this.pendingaudits.push({
							id: entry.requestID,
							sender: entry.senderName || entry.sender,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							expiryDate: daysToExpiry,
							template: entry.templateName,
							complete: createAccess ? null : undefined
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		getColorsForExpiry(expiryDate){
			if(expiryDate === "Expired"){
				return "red--text"
			}else if ( expiryDate <= 14 ) {
				return "orange--text"
			}
		}
	}
}
</script>
<style>
.completed-table thead th {
    font-size: 14px !important;
}
.pending-table thead th {
    font-size: 14px !important;
}
</style>
